import { Component, AfterViewInit, OnInit, HostListener, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { MainService } from '../../../service/main.service';
import { AuthenticationService } from '../../../../authentication.service';
import { MainService as portal_mainService } from '../../../../portal/service/main.service';
import { Router } from '@angular/router';
import { session } from '../../../../../environments/environment.session'
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
import html2canvas from 'html2canvas';
@Component({
  selector: '[app-header]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  showUserMenu = false;
  constructor(private cd: ChangeDetectorRef, public auth: AuthenticationService, public router: Router, public portal_main: portal_mainService,
    public mainService: MainService, private utf8EncodingService: Utf8EncodingService) { }

  erpUser: any = {};
  roles: any[] = ['user', 'admin', 'super-admin']
  async ngOnInit() {
    this.cd.detectChanges();
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    await this.portal_main.getUserImage(this.erpUser['user_id']);
    await this.portal_main.getAccImage(this.erpUser['b_acct_id']);
    await this.portal_main.getAccountInfo(this.erpUser['b_acct_id']);
    await this.portal_main.getHeaderInfo(this.erpUser['b_acct_id']);
    await this.changeLanguage();
    this.mainService.accInfo = this.portal_main.accInfo;
    this.erpUser = JSON.parse(atob(session?.erpUser))
    this.mainService.data$.subscribe(data => {
      this.erpUser = data;

    });
  }


  changeLanguage() {
    this.mainService.language_cd = this.auth.language_cd
  }

  home() {
    this.router.navigate(['/index'])
  }

  ngAfterViewInit() {
  }


  toggleUserMenu() {
    this.showUserMenu = !this.showUserMenu;
  }

  @HostListener('document:click', ['$event'])
  onDocClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (!target.closest('.user-menu') && !target.closest('.avatar-btn')) {
      this.showUserMenu = false;
    }
  }

  async logOut() {
    this.showUserMenu = false
    sessionStorage.removeItem("1001");
    sessionStorage.removeItem("1000");
    sessionStorage.removeItem("1005");
    session.erpUser = undefined
    await this.router.navigate(['/login']);
  }

  goToProfile() {
    this.router.navigate(['/acms/acms-profile'])
    this.toggleUserMenu()
  }


  exportAsImage() {
    const element: any = document.getElementById('download-area');

    html2canvas(element).then((canvas: any) => {
      const image = canvas.toDataURL('image/png');

      const link = document.createElement('a');
      link.href = image;
      link.download = 'component.png';
      link.click();
    });
  }
}